<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-tabs v-model="activeTab">
          <v-tab>Fakturaposter</v-tab>
          <v-tab>Exponeringsutrustning</v-tab>
          <v-tab>Tilläggsfakturering</v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item>          
            <v-card flat>
              <v-card-title class="text-h5">
                Fakturaposter
                <v-toolbar flat>
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="800px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Lägg till
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5">
                        Fakturering
                      </v-card-title>
                      <v-divider />
                      <v-card-text>
                        <v-form ref="form">
                          <v-row>
                            <v-col cols="12" md="3" sm="6">
                              <v-text-field v-model="editedItem.customerNumber" label="Kundnummer" outlined dense />
                            </v-col>  
                            <v-col cols="12" md="3" sm="6">
                              <v-select
                                v-model="editedItem.magazineTitle"
                                :items="['Aftonbladet', 'Expressen']"
                                label="Magasin"
                                outlined
                                dense
                              />
                            </v-col>
                            <v-col cols="12" md="3" sm="6">
                              <v-select
                                v-model="editedItem.productGroup"
                                :items="['Exponeringsutrustning','Huvudtidning', 'Bilaga']"
                                label="Produktgrupp"
                                outlined
                                dense
                              />
                            </v-col>               
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="3" sm="6">
                              <v-text-field v-model="editedItem.articleId" label="Artikel id" outlined dense />
                            </v-col>
  
                            <v-col cols="12" md="3" sm="6">
                              <v-text-field v-model="editedItem.articleName" label="Artikelnamn" outlined dense />
                            </v-col>
  
                            <v-col cols="12" md="3" sm="6">
                              <v-menu                   
                                ref="datePicker"     
                                v-model="datePicker"
                                :close-on-content-click="false"                        
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="editedItem.deliveryDate"
                                    label="Leveransdatum"
                                    prepend-icon="mdi-calendar"                            
                                    v-bind="attrs"
                                    outlined
                                    dense
                                    v-on="on"
                                  />
                                </template>
                                <v-date-picker v-model="editedItem.deliveryDate" first-day-of-week="1">
                                  <v-spacer />
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="datePicker = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.datePicker.save(date)"
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
  
                            <v-col cols="12" md="3" sm="6">
                              <v-text-field v-model="editedItem.deliveredAmount" label="Leverart Antal" type="number" hide-spin-buttons="true" outlined dense />
                            </v-col>
                            <v-col cols="12" md="3" sm="6">
                              <v-text-field v-model="editedItem.returnAmount" label="Returnerat Antal" type="number" hide-spin-buttons outlined dense />
                            </v-col>

                            <v-col v-if="['Exponeringsutrustning'].includes(editedItem.productGroup)" cols="12" md="3" sm="6">
                              <v-text-field v-model="editedItem.nettoPrice" label="Nettopris" type="number" suffix="kr" hide-detils="auto" :hide-spin-buttons="true" outlined dense />
                            </v-col>
                            <v-col v-else cols="12" md="3" sm="6">
                              <v-text-field v-model="editedItem.grossPrice" label="Bruttopris" type="number" suffix="kr" hide-spin-buttons outlined dense />
                            </v-col>
  
                            <v-col cols="12" md="3" sm="6">
                              <v-select
                                v-model="editedItem.vat"
                                :items="['0.0','6.0','12.0','25.0']"
                                label="Moms"
                                outlined
                                dense
                              />                      
                            </v-col>
                            <!-- Conditional Fields -->
                            <v-row v-if="['Huvudtidning', 'Bilaga'].includes(editedItem.productGroup)" class="pl-2">
                              <v-col cols="12" md="3" sm="6">
                                <v-text-field v-model="editedItem.editionId" label="Utgåve id" outlined dense />
                              </v-col>
                              <v-col cols="12" md="3" sm="6">
                                <v-text-field v-model="editedItem.productCode" label="Produktkod" outlined dense />
                              </v-col>
                              <v-col cols="12" md="3" sm="6">
                                <v-text-field v-model="editedItem.reclaimAmount" label="Reklamerat" type="number" hide-spin-buttons outlined dense />
                              </v-col>                                         
                              <v-col cols="12" md="3" sm="6">
                                <v-text-field v-model="editedItem.profitPercentage" label="Provision %" type="number" suffix="%" hide-spin-buttons outlined dense />
                              </v-col>  
                            </v-row>
       
  
                            <v-col cols="12" md="3" sm="6">
                              <v-text-field v-model="editedItem.ediReferenceText" label="EDI Referense text" outlined dense />
                            </v-col>
                          </v-row>
  
     
  
                          <!-- <v-btn color="primary" class="mt-3" @click="submitForm">
                    Submit
                  </v-btn> -->
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="save"
                        >
                          Spara
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5">
                        Är du säker att du vill radera?
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn color="blue darken-1" text @click="closeDelete">
                          Cancel
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">
                          OK
                        </v-btn>
                        <v-spacer />
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </v-card-title>
              <v-card-subtitle class="red--text grey lighten-3">
                Lägg till fakturaposter per utgivare för att skicka till fakturering och klicka på skicka.
                Blanda inte olika utgivare i samma fakturaposter.
              </v-card-subtitle>
              <v-data-table 
                :headers="headers" 
                :items="transactions" 
                dense        
                hide-default-header
                :footer-props="{
                  'items-per-page-options': [10, 25, 50, -1],
                  'items-per-page-text': 'Rader per sida:'
                }"
              >
                <template v-slot:header="{ props }">
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      class="custom-header"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
            
                <template v-slot:item="{ item }">
                  <tr>        
                    <td>{{ item.customerNumber }}</td>
                    <td>{{ item.magazineTitle }}</td>
                    <td>{{ item.productGroup }}</td>
                    <td>{{ item.articleId }}</td>
                    <td>{{ item.articleName }}</td>
                    <td>{{ item.editionId }}</td>
                    <td>{{ item.productCode }}</td>
                    <td>{{ item.deliveryDate }}</td>
                    <td>{{ item.deliveredAmount }}</td>          
                    <td>{{ item.reclaimAmount }}</td> 
                    <td>{{ item.returnAmount }}</td>
                    <td>{{ item.grossPrice }} kr</td>
                    <td>{{ item.vat }}%</td>
                    <td>{{ item.profitPercentage }}%</td>
                    <td>{{ item.ediReferenceText }}</td>
                    <td>
                      <span>
                        <v-icon
                          small                
                          @click="editItem(item)"
                        >
                          mdi-pencil
                        </v-icon>        
                        <v-icon
                          small
                          @click="deleteItem(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </span>
                    </td>
                  </tr>
                </template>    
              </v-data-table>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="send"
                >
                  Skicka
                </v-btn>
              </v-card-actions>
            </v-card>
      
            <v-card>
              <v-card-title class="text-h5">
                Väntande fakturaposter
          
                <v-dialog v-model="dialogDeleteSaved" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">
                      Är du säker att du vill radera väntande post?
                    </v-card-title>
                    <v-card-subtitle>
                      {{ this.editedItem.customerNumber }} - {{ this.editedItem.magazineTitle }}
                    </v-card-subtitle>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="blue darken-1" text @click="closeDeleteSaved">
                        Cancel
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="deleteSavedItemConfirm">
                        OK
                      </v-btn>
                      <v-spacer />
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card-title>
              <v-data-table 
                :headers="headers" 
                :items="waitingTransactions"           
                :loading="loading"
                loading-text="Laddar väntande fakturaposter..."
                group-by="importedInvoiceFileId"          
                dense        
                hide-default-header
                show-group-by
                :footer-props="{
                  'items-per-page-options': [10, 25, 50, -1],
                  'items-per-page-text': 'Rader per sida:'
                }"
              >
                <template v-slot:group.header="{ group }">                  
                  <td colspan="15" class="group-header-cell">              
                    <div class="d-flex justify-space-between align-center px-2">
                      <span>Faktura fil nr:{{ group }} ({{ getGroupItemCount(group) }} poster)</span>
                      <span>Total: {{ calculateGroupTotal(group) }} kr</span>
                    </div>
                  </td>                  
                </template>
                <template v-slot:header="{ props }">
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      class="custom-header"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
          
                <template v-slot:item="{ item }">
                  <tr>        
                    <td>{{ item.customerNumber }}</td>
                    <td>{{ item.magazineTitle }}</td>
                    <td>{{ item.productGroup }}</td>
                    <td>{{ item.articleId }}</td>
                    <td>{{ item.articleName }}</td>
                    <td>{{ item.editionId }}</td>
                    <td>{{ item.productCode }}</td>
                    <td>{{ item.deliveryDate }}</td>
                    <td>{{ item.deliveredAmount }}</td>          
                    <td>{{ item.reclaimAmount }}</td>
                    <td>{{ item.returnAmount }}</td>
                    <td>{{ item.grossPrice }} kr</td>
                    <td>{{ item.vat }}%</td>
                    <td>{{ item.profitPercentage }}%</td>
                    <td>{{ item.ediReferenceText }}</td>
                    <td>
                      <span>                               
                        <v-icon
                          small
                          @click="deleteSavedItem(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </span>
                    </td>
                  </tr>
                </template>    
              </v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab-item>  
            <invoice-upload @invoice-uploaded="loadData" />    
          </v-tab-item>
          <v-tab-item>
            <extra-invoice-upload @extra-invoice-uploaded="loadData" />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-col>
  </v-row>
</template>
  

<script>
import adminApi from '@/backend/adminapi'
import log from '@/logger'
import InvoiceUpload from '../../components/admin/InvoiceUpload.vue'
import ExtraInvoiceUpload from '../../components/admin/ExtraInvoiceUpload.vue'
export default {
  name: 'Invoice',
  components: {
    InvoiceUpload,
    ExtraInvoiceUpload,
  },
  data() {
    return {
      activeTab: 0,
      dialog: false,
      dialogDelete: false,
      dialogDeleteSaved: false,
      loading: false,
      editedIndex: -1,      
      datePicker: false,      
      transactions: [],
      waitingTransactions: [],
      headers: [       
        { text: 'Kundnummer', value: 'customerNumber' },
        { text: 'Magasin', value: 'magazineTitle'},
        { text: 'Produktgrupp', value: 'productGroup' },
        { text: 'Artikel id', value: 'articleId'  },
        { text: 'Artikelnamn', value: 'articleName'},
        { text: 'Utgåve id', value: 'editionId'},
        { text: 'Produktkod', value: 'productCode'},        
        { text: 'Leveransdatum', value: 'deliveryDate' },
        { text: 'Antal', value: 'deliveredAmount'},                        
        { text: 'Reklamerat', value: 'reclaimAmount'},
        { text:'Returnera', value: 'returnAmount'},        
        { text: 'Brutto pris', value: 'grossPrice'},
        { text: 'Moms', value: 'vat' },
        { text: 'Provision', value: 'profitPercentage'},        
        { text: 'EDI Ref', value: 'ediReferenceText'},
        { text: '' },
      ],
      editedItem: {
        id:null,
        magazineTitle: null,
        customerNumber: '',
        productGroup: null,
        articleId: '',
        articleName: '',    
        editionId: '',
        deliveryDate:  (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        deliveredAmount: '',
        grossPrice: null,
        nettoPrice: null,
        vat: 0,
        ediReferenceText: '',                
        reclaimAmount: 0, 
        returnAmount: 0,
        profitPercentage: 0,        
        productCode: '',
      },
      defaultItem: {
        magazineTitle: null,
        customerNumber: '',
        productGroup: null,
        articleId: '',
        articleName: '',
        editionId: '',
        deliveryDate: '',
        deliveredAmount: 0,
        grossPrice: null,
        nettoPrice: null,
        vat: 0,
        ediReferenceText: '',        
        reclaimAmount: 0,
        returnAmount: 0,
        profitPercentage: 0,      
        productCode: '',
      },
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },   
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
  },
   mounted() {
    this.loadData()
  },
  methods: {  
    loadData() {
      this.loading = true
      adminApi.adminGetExtraInvoice()
       .then((resp) => {          
          log.debug('Wating extra invoices:' + resp.data)
          this.waitingTransactions = resp.data                          
        })
        .catch((error) => {
          log.debug('Error - Getting extra invoices:', error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    customGroupName(group) {
      console.log('Group received:', group)
      const mapping = {
        importedInvoiceFileId: 'Faktura fil',      
      }
      return mapping[group] || group
    },
    editItem(item) {
      this.editedIndex = this.transactions.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem(item) {
      this.editedIndex = this.transactions.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },   
    deleteItemConfirm() {
      this.transactions.splice(this.editedIndex, 1)
      this.closeDelete()
    },
    deleteSavedItem(item) {
      this.editedIndex = this.waitingTransactions.indexOf(item)
      this.editedItem = Object.assign({}, item)
      log.debug('Deleting saved item at index', this.editedIndex,'with item :', this.editedItem)
      this.dialogDeleteSaved = true
    },
    deleteSavedItemConfirm() {
      //const item = this.editedItem
      adminApi.adminDeleteExtraInvoice(this.editedItem)
      .then(() => {
        //const index = this.waitingTransactions.findIndex(transaction => transaction.id === item.id)
        log.debug('Remove deleted item from waiting transactions at index', this.editedIndex, 'with item :', this.editedItem)
        if (this.editedIndex !== -1) {
          this.waitingTransactions.splice(this.editedIndex, 1)
        }
        this.closeDeleteSaved()
      })
      .catch(error => {
        log.error('Error - Deleting extra invoice:', error)
        this.closeDeleteSaved()
      })      
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    closeDeleteSaved() {
      this.dialogDeleteSaved = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    save() {

      if(['Exponeringsutrustning'].includes(this.editedItem.productGroup)){
        this.editedItem.grossPrice = this.editedItem.nettoPrice * (1 + this.editedItem.vat/100)
      }
      
      if (this.editedIndex > -1) {
        Object.assign(this.transactions[this.editedIndex], this.editedItem)
      } else {

        this.transactions.push(this.editedItem)
      }
      this.close()
    },
    send(){
      log.debug(this.transactions)
    
      adminApi.adminAddInvoice(this.transactions).then((resp) => {
        log.debug('Response:', resp)
        this.transactions = []
        this.loadData()
      })
      // Send data to backend
    },   
    getGroupItemCount(groupId) {
      return this.waitingTransactions.filter(item => item.importedInvoiceFileId === groupId).length
    },
    calculateGroupTotal(groupId) {
      return this.waitingTransactions
        .filter(item => item.importedInvoiceFileId === groupId)
        .reduce((total, item) => total + (item.grossPrice || 0) * (item.deliveredAmount - (item.returnAmount || 0) || 0) , 0)
        .toFixed(2)
    },
  },
}
</script>

<style scoped>
.custom-header {    
  font-weight: 500;
  text-align: left;
  padding: 0 12px;
}
/* Add these new styles */
.d-flex {
  display: flex !important;
}

.justify-space-between {
  justify-content: space-between !important;
}

td {
  white-space: nowrap;
}
.group-header-cell {
  width: 100%;
  padding: 8px 0;
  background-color: #f5f5f5;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  span{
    font-size: 1rem;
    font-weight: 300;
  }
}

.v-data-table ::v-deep .group-header-cell {
  white-space: normal !important;
  width: 100% !important;
   span{
    font-size: 1rem;
    font-weight: 300;
  }
}

</style>